<template>
  <WsMain>
    <WsCrud
      :modelName="$store.state.model[modelName].modelName"
      :label="$store.state.model[modelName].label"
      :fields="$store.state.model[modelName].fields"
      :liveSearching="true"
      :showFields="showFields"
    ></WsCrud>
  </WsMain>
</template>

<script>
export default {
  data: () => ({
    modelName: "quotation_description",
    showFields: ["id", "content"],
  }),
};
</script>